import { TYPESENSE_TOKEN_SEPARATOR } from 'src/constant';

export const crm_keys = [
  {
    value: 'contact',
    plural: 'Contacts',
    pluralLowerCase: 'contacts',
    singular: 'Contact',
    new: 'new_contact',
    about: 'about_contact',
    list: 'list_contact',
  },
  {
    value: 'company',
    plural: 'Companies',
    pluralLowerCase: 'companies',
    singular: 'Company',
    new: 'new_company',
    about: 'about_company',
    list: 'list_company',
  },
  {
    value: 'marketing_target',
    plural: 'Marketing Targets',
    pluralLowerCase: 'marketing_targets',
    singular: 'Marketing Target',
    about_text: 'Marketing',
    new: 'new_marketing_target',
    about: 'about_marketing_target',
    list: 'list_marketing_target',
  },
  {
    value: 'lead',
    plural: 'Leads',
    pluralLowerCase: 'leads',
    singular: 'Lead',
    new: 'new_lead',
    about: 'about_lead',
    list: 'list_lead',
  },
  {
    value: 'opportunity',
    plural: 'Opportunities',
    pluralLowerCase: 'opportunities',
    singular: 'Opportunity',
    new: 'new_opportunity',
    about: 'about_opportunity',
    list: 'list_opportunity',
  },
];

export const crm_activity_category = [
  { id: 'WGHbjXRC', value: 'logged_call', log_label: 'Log Call', label: 'Call', plural: 'Calls', scheduled_action: 'call' },
  { id: '4QXC2z4D', value: 'note', log_label: 'Note', label: 'Note', plural: 'Notes', scheduled_action: 'note' },
  { id: '9dnXGnkl', value: 'logged_sms', log_label: 'Log SMS', label: 'SMS', plural: 'SMS', scheduled_action: 'sms' },
  { id: 'KDsJ3JSy', value: 'logged_email', log_label: 'Log Email', label: 'Email', plural: 'Emails', scheduled_action: 'email' },
  { id: 'eexYQ8BC', value: 'logged_task', log_label: 'Log Task', label: 'Task', plural: 'Task', scheduled_action: 'task' },
];

export function findCRMValueByCRMKey(property, value) {
  const find = crm_keys.find(item => item[property] === value);
  return find ? find : null;
}

export function findCRMActivityCategory(value) {
  const find = crm_activity_category.find(item => item.value === value);
  return find ? find : null;
}

export function getFieldHasValue(field, crmRecordValues) {
  const findValue = crmRecordValues[field.id];
  let hasValue = findValue && findValue !== TYPESENSE_TOKEN_SEPARATOR ? Array.isArray(findValue) && !findValue.length ? false : true : false;
  if(['8cf69eaab28b', 'a5b375087d50', 'a5c614630401', '75a35e1b8968'].includes(field.id)) {
    hasValue = true;
  }
  if(['bef4783e6b7f', 'aa55ac4b9cc9', '74dc412eed50'].includes(field.id) && crmRecordValues[field.field_name]) {
    hasValue = true;
  }
  return hasValue;
}
